import { gql } from "@apollo/client";

export const getPaymentMethodsQuery = gql`
  query PaymentMethods($customerId: String!) {
    paymentMethods: paymentMethods_Admin(customerId: $customerId) {
      payables {
        accountFiatMethods {
          accountName
          accountDetailsText
        }
      }
    }
    accounts_Admin(customerId: $customerId) {
      paymentMethods {
        virtualAccounts {
          currency
          paymentMethods {
            paymentRail { displayName type instructionalText }
            accountDetailsDisplay
            accountDetailsCopy
          }
        }
        crypto {
          id
          accountId
          wallets {
            address
            network {
              id
              name
              longName
              iconUrl
              altIconUrls { smallDisplayIcon }
              uriPrefix
            }
            uri
          }
        }
        payId {
          payId
          payIdName
          status
        }
        autoMatcherAccount {
          accountName
          accountNumber
          bsb
          whitelistedSourceAccounts {
            displayAccountName
            accountName
            accountNumber
            bsbNumber
          }
        }
      }
      id
      name
    }
  }
`

